package one.healthium.profile.ui.update_age

internal sealed interface UpdateAgeEvent {
    data object OnAgeUpdated : UpdateAgeEvent
}